import { atom, selector } from 'recoil'

import { regexEmail } from 'mailup-react-helpers'

import {
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_DELIVER_ISP,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_NO_DELIVER
} from 'Api/beSendGoApi'

import { trustedEmailSenderState } from 'Hooks/useTrustedEmailSender'

import { PECPLUS_STATUS_COMPLETE_DESCR } from 'Constants'

export const isScheduledSendingState = atom({
  key: 'SendingWizardIsScheduledSendingState',
  default: {
    isScheduledSending: false,
    scheduleModeSelected: undefined,
    scheduleMode: []
  }
})

export const senderInfoState = atom({
  key: 'SendingWizardSenderInfoState',
  default: {
    isPEC: false,
    pecPlusStatus: undefined,
    queueStatus: undefined,
    idAsyncQueueConfig: undefined,
    queued: undefined,
    senderName: undefined,
    oldSenderName: undefined,
    senderEmail: undefined,
    oldSenderEmail: undefined,
    replyToEmail: undefined,
    customSender: false,
    idFieldSenderNameMail: undefined,
    idSenderEmailField: undefined,
    lastSendingId: undefined,
    lastSendingDate: undefined,
    fetchedSender: false,
    invalidReplyTo: false,
    customEmailValue: undefined,
    customEmaiLabel: undefined,
    customNameValue: undefined,
    customNameLabel: undefined,
    sendingOrScheduleId: undefined,
    senderIsDeleted: false,
    waitForVerified: false,
    savedAsDefault: undefined
  }
})

export const lastSendingState = atom({
  key: 'SendingWizardlastSendingState',
  default: {
    Id: 0,
    IdList: 0,
    IdInvio: 0,
    Action: '',
    State: '',
    ErrorCode: '',
    Queued: 0,
    Skipped: 0,
    ToBeQueued: 0,
    CreationDate: '',
    StartDate: '',
    UpdateDate: ''
  }
})

const validSenderStatus = [
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_NO_DELIVER,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_DELIVER_ISP
]

const validEmailRe = new RegExp(regexEmail)

export const isValidFormState = selector({
  key: 'SendingWizardEnableValidForm',
  get: ({ get }) => {
    const { isPEC, pecPlusStatus, senderEmail, senderName, replyToEmail } = get(
      senderInfoState
    )

    const { status: senderStatus } = get(
      trustedEmailSenderState('trustedSender')
    )

    const validSender = isPEC
      ? pecPlusStatus === PECPLUS_STATUS_COMPLETE_DESCR
      : validSenderStatus.includes(senderStatus)

    const x =
      !!senderEmail &&
      !!senderName &&
      senderName !== '' &&
      !!replyToEmail &&
      validEmailRe.test(senderEmail) &&
      validEmailRe.test(replyToEmail) &&
      validSender

    return (
      !!senderEmail &&
      !!senderName &&
      senderName !== '' &&
      !!replyToEmail &&
      validEmailRe.test(senderEmail) &&
      validEmailRe.test(replyToEmail) &&
      validSender
    )
  }
})
